<template>
  <v-hover v-slot:default="{ hover }">
    <v-card  class="mx-auto" color="grey lighten-4"  width="320px">
      <v-img :aspect-ratio="7/9" :src="img">
        <v-expand-transition>
          <div v-if="hover" class="d-flex transition-fast-in-fast-out orangebg v-card--reveal display-3" style="height: 100%;">
            <a :href="to">
            <h3   class="white--text center px-1">{{ datefinal }}<br>{{ title }}<br>Clique para ver</h3>
            </a>
          </div>
        </v-expand-transition>
      </v-img>
    </v-card>
  </v-hover>
</template>


<script>
export default {
  props: ['title', 'date', 'to', 'img'],
  computed: {
    datefinal() {
      return new Intl.DateTimeFormat('pt-BR').format(new Date(this.date))
    }
  },
}
</script>

<style>
.v-card--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  opacity: .5;
  position: absolute;
  width: 100%;
}

.photo-card photo {
  max-width: 336px;
  border-radius: 4px;
  background: #fff;
  display: grid;
  grid-template-rows: 200px auto;
  position: relative;
  padding: 15px;
}

.photo-card img {
  height: 100%;
  width: 100%;
  object-fit: cover;
  border-radius: 4px;
}
.photo-card h5 {
  white-space: normal;
}
.photo-card time {
  position: absolute;
  top: 8px;
  left: -4px;
  width: 60px;
  border-radius: 2px;
  display: grid;
  grid-template-rows: 60px 20px;
  padding-left: 2px;
}
.photo-card .photo-card-month {
  line-height: 14px !important;
}
.photo-card .photo-card-day {
  line-height: 18px !important;
}
.orangebg{
  background: #b18e3c;
}
</style>